/**
 * Check if a keyboard event matches a keybinding definition
 * @param {KeyboardEvent} event - The keyboard event
 * @param {object} binding - The keybinding definition
 * @returns {boolean} True if the event matches the binding
 */
export function matchesKeybinding(event, binding) {
  if (event.key.toLowerCase() !== binding.key.toLowerCase()) {
    return false;
  }

  if (binding.modKey) {
    return event.metaKey || event.ctrlKey;
  }

  return (
    !!event.altKey === !!binding.altKey &&
    !!event.ctrlKey === !!binding.ctrlKey &&
    !!event.metaKey === !!binding.metaKey &&
    !!event.shiftKey === !!binding.shiftKey
  );
}

export const KEYBINDINGS = {
  CREATE_DOCUMENT: { key: "f", altKey: true, display: "alt+f" },
  OPEN_SEARCH: { key: "b", altKey: true, display: "alt+b" },
  OPEN_JOURNAL: { key: "j", altKey: true, display: "alt+j" },
  OPEN_CAPTURE: { key: "q", altKey: true, display: "alt+q" },
  PREVIOUS_DOCUMENT: { key: "p", altKey: true, display: "alt+p" },
  NEXT_DOCUMENT: { key: "n", altKey: true, display: "alt+n" },
  TOGGLE_EDIT: { key: "e", altKey: true, display: "alt+e" },
  SAVE: { key: "s", altKey: true, display: "alt+s" },
  CLOSE_DOCUMENT: { key: "c", altKey: true, display: "alt+c" },
  CANCEL: { key: "Escape", display: "esc" },
  CONFIRM: { key: "Enter", modKey: true, display: "ctrl+enter" },
};
